import { ENV } from './globals'


window.ENV ||= {} as ENV

const gatewayUrl = `https://dev.inoviaai.se`
const websocketUrl = `wss://dev.inoviaai.se/ws`

// const gatewayUrl = `https://inoviaai.b2b.se`
// const websocketUrl = `wss://inoviaai.b2b.se/ws`


export const {
  CC_PUBLIC_URL = '',
  GATEWAY_URL = gatewayUrl,
  WEBSOCKET_DEV_URL = websocketUrl,
  FIREBASE_API_KEY = 'AIzaSyCKJwXKKru4ouNl6_fEXEUNRs-qBkyyYH8',
  FIREBASE_AUTH_DOMAIN = 'inovia-prod.firebaseapp.com',
  FIREBASE_PROJECT_ID = 'inovia-prod',
  SO_APP_ID = '182a523198438cd394e83d0f0f9dbd5c',
  SO_ENV = 'online'
} = window.ENV
